export default "__VITE_ASSET__a798901b__"